// extracted by mini-css-extract-plugin
module.exports = {"time":"CountdownTimer_time__eQxtU","spin":"CountdownTimer_spin__eYDJo","loader":"CountdownTimer_loader__hor_x"};